import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'

const STORAGE_VERSION = 'v2'
if (localStorage.getItem('appVersion') !== STORAGE_VERSION) {
    localStorage.clear()
    sessionStorage.clear()
    localStorage.setItem('appVersion', STORAGE_VERSION)
}

window.onerror = function(msg, src, line, col, error) {
  console.error('GLOBAL ERROR:', {
    msg, src, line, col,
    stack: error?.stack,
    fullError: JSON.stringify(error)
  });
};

window.addEventListener('unhandledrejection', (e) => {
  console.error('UNHANDLED PROMISE:', {
    reason: e.reason,
    stack: e.reason?.stack
  });
});

const root = ReactDOM.createRoot(document.getElementById('root'))
const AppTree = import.meta.env.PROD ? (
    <React.StrictMode>
        <App />
    </React.StrictMode>
) : (
    <App />
)

root.render(AppTree)